import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { handleLogOut } from "utils/auth/auth-context";
import { useNavigate } from "react-router-dom";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import styles from "./Logout.module.scss";

export function Logout() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        handleLogOut();
    }, []);

    const handleReLogin = () => {
        navigate("/home", { replace: true });
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <span>You have been logged out successfully!</span>
                <PrimaryButton onClick={handleReLogin}>
                    {t("common.login")}
                </PrimaryButton>
            </div>
        </div>
    )
}
